import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Providers from './Providers';
import { initSentry } from './sentry';

// Initialize Sentry
initSentry();

const rootElement: HTMLElement = document.getElementById('root');
createRoot(rootElement).render(
    <StrictMode>
        <Providers>
            <App />
        </Providers>
    </StrictMode>,
);
